<template>
  <div>
    <b-alert
      variant="success"
      :show="showAlert_success"
      @dismissed="showAlert_success = false"
      >{{ alert_success_message }}</b-alert
    >

    <b-alert
      variant="danger"
      :show="showAlert_error"
      @dismissed="showAlert_error = false"
      >{{ alert_error_message }}</b-alert
    >

    <b-container fluid>
      <h3 class="mt-3 mb-3">Inventory Dashboard [NEW]</h3>

      <div class="search_bar mb-3">
        <b-row v-if="this.$store.state.user_obj.account_type == 'admin'">
          <b-col cols="4" class="pr-1">
            <b-form-file
              v-model="upload_file"
              placeholder="Choose a file..."
            ></b-form-file>
          </b-col>

          <b-col class="text-left p-0">
            <b-button
              class="btn-action"
              size="sm"
              variant="info"
              @click="onUploadFile"
              >Upload</b-button
            >
          </b-col>
        </b-row>

        <b-row class="mt-2">
          <b-col cols="2" class="pr-1">
            <b-form-select
              size="sm"
              v-model="search_criteria.status_selected"
              :options="status_options"
            />
          </b-col>
          <b-col cols="2" class="pl-0 pr-1">
            <b-form-input
              id="input-small"
              size="sm"
              type="date"
              v-model="search_criteria.end_at"
            ></b-form-input>
          </b-col>
          <b-col cols="3" class="pl-0 pr-1">
            <b-form-input
              id="input-small"
              size="sm"
              type="text"
              placeholder="SKU"
              v-model="search_criteria.keyword"
             @keyup.enter="onSearch"></b-form-input>
          </b-col>
          <b-col class="text-left p-0">
            <b-button
              class="btn-action"
              size="sm"
              variant="info"
              @click="onSearch"
            >
              <font-awesome-icon class="mr-1" icon="search" />Search
            </b-button>

            <b-button
              class="btn-action"
              size="sm"
              variant="info"
              @click="exportCSV"
              >Export</b-button
            >

            <b-button
              class="btn-action"
              size="sm"
              variant="info"
              @click="exportCSVClient"
              >Export Client View</b-button
            >
          </b-col>
        </b-row>

        <b-row class="mt-2 ">
          <b-col>
            <strong>Column Filters</strong>
          </b-col>
        </b-row>
        <b-row class="">
          <b-col>
            <!-- <b-form-checkbox
              class="chkbox_row"
              plain
              id="chkbox_cnt_total"
              :value="true"
              v-model="col_filter.cnt_total"
              inline
            >
              Total
            </b-form-checkbox> -->

            <b-form-checkbox
              class="chkbox_row"
              plain
              id="chkbox_cnt_active"
              :value="true"
              v-model="col_filter.cnt_active"
              inline
              @change="onColumnFilterClick('cnt_active')"
            >
              Active
            </b-form-checkbox>

            <b-form-checkbox
              class="chkbox_row"
              plain
              id="chkbox_cnt_damaged"
              :value="true"
              v-model="col_filter.cnt_damaged"
              @change="onColumnFilterClick('cnt_damaged')"
              inline
            >
              Damaged
            </b-form-checkbox>

            <b-form-checkbox
              class="chkbox_row"
              plain
              id="chkbox_cnt_hold"
              :value="true"
              v-model="col_filter.cnt_hold"
              @change="onColumnFilterClick('cnt_hold')"
              inline
            >
              Hold
            </b-form-checkbox>

            <b-form-checkbox
              class="chkbox_row"
              plain
              id="chkbox_cnt_expired"
              :value="true"
              v-model="col_filter.cnt_expired"
              @change="onColumnFilterClick('cnt_expired')"
              inline
            >
              Expired
            </b-form-checkbox>

            <b-form-checkbox
              class="chkbox_row"
              plain
              id="chkbox_cnt_committed"
              :value="true"
              v-model="col_filter.cnt_committed"
              @change="onColumnFilterClick('cnt_committed')"
              inline
            >
              Committed
            </b-form-checkbox>

            <b-form-checkbox
              class="chkbox_row"
              plain
              id="chkbox_cnt_other"
              :value="true"
              v-model="col_filter.cnt_other"
              @change="onColumnFilterClick('cnt_other')"
              inline
            >
              Other
            </b-form-checkbox>
          </b-col>
        </b-row>
      </div>

      <b-pagination
        size="sm"
        :total-rows="total_rows"
        v-model="currentPage"
        :per-page="2000"
        @change="onPageChange"
        :limit="PAGING_LIMIT"
      ></b-pagination>

      <b-table
        id="btable_main"
        responsive
        small
        outlined
        striped
        hover
        sticky-header="500px"
        :items="items"
        :fields="fields"
      >
        <template v-slot:head(cnt_total)="data">
          <div class="div_cnt">
            Total
            <span class="toggle_qty" v-if="!showQty" @click="toggleQty"
              >Expand</span
            >
            <span class="toggle_qty" v-if="showQty" @click="toggleQty"
              >Hide</span
            >
          </div>
        </template>

        <template v-slot:cell(cnt_total)="data">
          <div class="div_cnt">
            {{ number_formatter(data.item.cnt_total) }}
          </div>
        </template>

        <template v-slot:head(cnt_active)="data">
          <div class="div_cnt">
            Active
          </div>
        </template>

        <template v-slot:cell(cnt_active)="data">
          <div class="div_cnt">
            {{ number_formatter(data.item.cnt_active) }}
          </div>
        </template>

        <template v-slot:head(cnt_damaged)="data">
          <div class="div_cnt">
            Damaged
          </div>
        </template>

        <template v-slot:cell(cnt_damaged)="data">
          <div class="div_cnt">
            {{ number_formatter(data.item.cnt_damaged) }}
          </div>
        </template>

        <template v-slot:head(cnt_hold)="data">
          <div class="div_cnt">
            Hold
          </div>
        </template>

        <template v-slot:cell(cnt_hold)="data">
          <div class="div_cnt">
            {{ number_formatter(data.item.cnt_hold) }}
          </div>
        </template>

        <template v-slot:head(cnt_expired)="data">
          <div class="div_cnt">
            Expired
          </div>
        </template>

        <template v-slot:cell(cnt_expired)="data">
          <div class="div_cnt">
            {{ number_formatter(data.item.cnt_expired) }}
          </div>
        </template>

        <template v-slot:head(cnt_committed)="data">
          <div class="div_cnt">
            Committed
          </div>
        </template>

        <template v-slot:cell(cnt_committed)="data">
          <div class="div_cnt">
            {{ number_formatter(data.item.cnt_committed) }}
          </div>
        </template>

        <template v-slot:head(cnt_other)="data">
          <div class="div_cnt">
            Other
          </div>
        </template>

        <template v-slot:cell(cnt_other)="data">
          <div class="div_cnt">
            {{ number_formatter(data.item.cnt_other) }}
          </div>
        </template>

        <template v-slot:cell(updated_at)="data">
          <div v-if="data.item.updated_by != ''">
            {{ data.item.updated_at }}
          </div>
        </template>

        <template v-slot:head(expired)="data">
          <div class="div_cnt">
            Expired
          </div>
        </template>

        <template v-slot:cell(expired)="data">
          <div class="dot_container">
            <div
              v-if="!data.item.cnt_expired || data.item.cnt_expired == 0"
              class="dot_expired"
            ></div>
            <div
              v-if="data.item.cnt_expired > 0"
              class="dot_expired red_light"
            ></div>
          </div>
        </template>

        <template v-slot:head(critical_level)="data">
          <div class="div_cnt">
            Critical Level
          </div>
        </template>

        <template v-slot:cell(critical_level)="data">
          <div class="dot_container">
            <div
              v-if="data.item.cnt_total >= 200"
              class="dot_critical_level"
            ></div>
            <div
              v-if="data.item.cnt_total < 200 && data.item.cnt_total >= 100"
              class="dot_critical_level yellow_light"
            ></div>
            <div
              v-if="data.item.cnt_total < 100"
              class="dot_critical_level red_light"
            ></div>
          </div>
        </template>

        <template v-slot:cell(action)="data">
          <b-button
            class="btn-action"
            size="sm"
            variant="info"
            :to="{
              name: 'tracking_detail',
              params: { id: data.item.tracking_id }
            }"
            :disabled="!data.item.tracking_id"
            >Detail</b-button
          >

          <b-button
            v-if="
              ($store.state.user_obj.account_type == 'admin' ||
                $store.state.user_obj.account_type == 'cs') &&
                data.item.status == 'pending'
            "
            class="btn-action"
            size="sm"
            variant="success"
            @click.stop="executeCR(data.item)"
            >Execute</b-button
          >

          <b-button
            v-if="data.item.status == 'pending'"
            class="btn-action"
            size="sm"
            variant="danger"
            @click.stop="cancelCR(data.item)"
            >Cancel</b-button
          >
        </template>
      </b-table>

      <b-pagination
        size="sm"
        :total-rows="total_rows"
        v-model="currentPage"
        :per-page="2000"
        @change="onPageChange"
        :limit="PAGING_LIMIT"
      ></b-pagination>
    </b-container>
  </div>
</template>

<script>
import moment from "moment";
import VueBarcode from "vue-barcode";

const fields_show_qty = [
  // {
  //   key: "category",
  //   label: "Primary Category"
  // },
  {
    key: "product_sku",
    label: "Product SKU"
  },
  {
    key: "other_sku",
    label: "Other SKU"
  },
  {
    key: "product_description",
    label: "Product Description"
  },
  {
    key: "cnt_total",
    label: "Total"
  },
  {
    key: "cnt_active",
    label: "Active",
    class: "hide"
  },
  {
    key: "cnt_committed",
    label: "Committed",
    class: "hide"
  },
  {
    key: "cnt_hold",
    label: "Hold",
    class: "hide"
  },
  {
    key: "cnt_expired",
    label: "Expired",
    class: "hide"
  },
  {
    key: "cnt_damaged",
    label: "Damaged",
    class: "hide"
  },
  {
    key: "cnt_other",
    label: "Other",
    class: "hide"
  },
  {
    key: "expired",
    label: "Expired"
  },
  {
    key: "critical_level",
    label: "Critical Level"
  }
];

const fields_hide_qty = [
  {
    key: "product_sku",
    label: "SKU"
  },
  {
    key: "product_description",
    label: "Description"
  },
  {
    key: "cnt_total",
    label: "Total"
  },
  {
    key: "expired",
    label: "Expired"
  },
  {
    key: "critical_level",
    label: "Critical Level"
  }
];

export default {
  name: "InventoryControl",
  inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT", "NODEJS_API_URL"],
  components: {
    barcode: VueBarcode
  },
  data() {
    return {
      col_filter: {
        cnt_total: true,
        cnt_active: false,
        cnt_damaged: false,
        cnt_hold: false,
        cnt_expired: false,
        cnt_committed: false,
        cnt_other: false
      },
      courier_options: [],
      export_date: {
        start_at: moment()
          .subtract(7, "d")
          .format("YYYY-MM-DD"),
        end_at: moment().format("YYYY-MM-DD")
      },
      upload_file: [],
      loader_full: false,
      loader: false,
      items: [],
      showQty: false,
      fields: fields_show_qty,
      currentPage: 1,
      table_offset: 0,
      total_rows: 0,
      updating_item: false,
      export_criteria: {
        courier_selected: null,
        status_selected: null
      },
      search_criteria: {
        keyword: "",
        status_selected: null,
        end_at: moment().format("YYYY-MM-DD"),
      },
      showAlert_success: false,
      alert_success_message: "",

      showAlert_error: false,
      alert_error_message: "",

      status_options: [
        {
          value: null,
          text: "All Status"
        },
        {
          value: "Expired",
          text: "Expired"
        },
        {
          value: "Critical Level",
          text: "Critical Level"
        }
      ]
    };
  },
  async created() {
    await this.getInventoryControl();
    this.initialized = true;
  },
  mounted() {
    this.loader = this.$loading.show({
      isFullPage: true,
      canCancel: false
    });
  },
  methods: {
    onColumnFilterClick(column_name) {
      let cnt_indexs = {
        cnt_active: 4,
        cnt_damaged: 5,
        cnt_hold: 6,
        cnt_expired: 7,
        cnt_committed: 8,
        cnt_other: 9
      };
      let cnt_index = cnt_indexs[column_name];
      if (this.col_filter[column_name]) {
        this.fields[cnt_index].class = "hide";
      } else {
        this.fields[cnt_index].class = "";
      }
      this.$root.$emit("bv::refresh::table", "btable_main");
    },

    toggleQty() {
      this.fields[6].class = "hide";
      console.log(this.fields);

      if (this.showQty) {
        this.showQty = false;
        let cnt_indexs = [5, 6, 7, 8, 9];
        for (let i in cnt_indexs) {
          let cnt_index = cnt_indexs[i];
          this.fields[cnt_index].class = "hide";
        }

        for (let i2 in this.col_filter) {
          this.col_filter[i2] = false;
        }
      } else {
        this.showQty = true;
        let cnt_indexs = [4, 5, 6, 7, 8, 9];
        for (let i in cnt_indexs) {
          let cnt_index = cnt_indexs[i];
          this.fields[cnt_index].class = "";
        }

        for (let i2 in this.col_filter) {
          this.col_filter[i2] = true;
        }
      }

      this.$root.$emit("bv::refresh::table", "btable_main");
    },

    number_formatter: value => {
      if (!value) {
        return "-";
      }
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    exportCSV() {
      let export_url =
        process.env.VUE_APP_API_HOST + "/export_inventory_control.php?";
      export_url += "&client_id=" + this.$store.state.user_obj.client_id;
      export_url = encodeURI(export_url);
      window.open(export_url, "_blank");
    },
    exportCSVClient() {
      this.loader = this.$loading.show({
        isFullPage: true,
        canCancel: false
      });

      this.$http({
        url: this.NODEJS_API_URL + "/gen_excel",
        method: "POST",
        data: {
          export_type: "client_inventory_control",
          limit: 999999,
          search_criteria: this.search_criteria,
          client_id: this.$store.state.user_obj.client_id
        },
        responseType: "blob" // important
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "client_inventory.xlsx");
        document.body.appendChild(link);
        link.click();

        this.loader.hide();
      });
    },

    displayDate(d) {
      if (d) {
        return moment(d).format("YYYY-MM-DD");
      } else {
        return "/";
      }
    },

    async getInventoryControl() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "inventory_control_get_v2.php",
        data: {
          offset: this.table_offset,
          limit: 2000,
          search_criteria: this.search_criteria,
          client_id: this.$store.state.user_obj.client_id
        }
      });
      this.items = response.data.products;
      this.total_rows = parseInt(response.data.total_rows);
      this.loader.hide();
    },

    onSearch() {
      for (const key in this.search_criteria) {
        if (typeof this.search_criteria[key] === "string") {
          this.search_criteria[key] = this.search_criteria[key].trim();
        }
      }
      this.getInventoryControl();
    },

    onPageChange(page_to_change) {
      this.table_offset = (page_to_change - 1) * 2000;
      this.getInventoryControl();
    },

    async onUploadFile() {
      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false
      });

      let formData = new FormData();
      formData.append("excel_file", this.upload_file);

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "wms_inventory_import.php",
        headers: {
          "Content-Type": "multipart/form-data"
        },
        data: formData
      });

      if (response) {
        this.loader_full.hide();
        // alert("Upload success");
        window.location.reload();
      }
    }
  }
};
</script>

<style>
th,
td {
  white-space: nowrap;
}

.div_cnt {
  text-align: center;
}

.hide {
  display: none;
}

.toggle_qty {
  font-size: 12px;
  border: 1px solid #eaeaea;
  padding: 2px 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/InventoryControlNew.vue